import moment from 'moment-timezone';
import React from 'react';
import utils from '../../../services/utils';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';

import classes from './DetailInvoiceCharge.module.scss';
import Tags from '../../Tags/Tags';
import { generalConceptValueLabelsObject } from '../../../store/catalogs/puc';
import NoticeCard from '../../NoticeCard/NoticeCard';

const DetailInvoiceCharge = ({ supplier, invoice, showDetailPay, isHistoryPayment }) => {
  const itemsQuantity = Array.isArray(invoice?.items) ? invoice.items.length : 0;
  const chargeDescription =
    invoice?.description ||
    invoice?.descriptionItems ||
    invoice?.items?.[0]?.description ||
    invoice?.items?.[0]?.nameProduct ||
    'N/A';

  return (
    <div className={classes.fields}>
      <span className='semibold-18'>Información general de la cuenta de cobro</span>
      <FieldBold title='PROVEEDOR' value={supplier} />
      {isHistoryPayment && (
        <div className={classes.grid}>
          <FieldBold title='TIPO DE PAGO' value={supplier.totalValueWasPayed}>
            <Tags
              type={supplier.totalValueWasPayed ? 'green' : 'gray'}
              text={supplier.totalValueWasPayed ? 'Pago total' : 'Pago parcial'}
            />
          </FieldBold>
          <FieldBold title='FECHA Y HORA PAGO' value={moment(supplier.dateCurrentPay).format('DD/MM/YYYY[,] hh:mm a')} />
        </div>
      )}
      <FieldBold title='CANTIDAD DE ÍTEMS' value={itemsQuantity} />
      <div className={classes.grid}>
        <FieldBold title='DESCRIPCIÓN' value={chargeDescription} />
        <FieldBold title='FECHA DE CREACIÓN' value={moment(invoice.issueDate).format('DD/MM/YYYY')} />
        <FieldBold title='FECHA DE VENCIMIENTO' value={moment(invoice.dueDate).format('DD/MM/YYYY')} />
        <FieldBold title='SUBTOTAL (SIN RETENCIONES)' value={utils.moneyFormat(invoice.lineExtensionAmount)} />
        <FieldBold title='MONTO TOTAL (CON RETENCIONES)' value={utils.moneyFormat(invoice.payableAmountAfterRetentions)} />
      </div>
      <div className={classes.pass}>
        {/* {invoice.payments.length !== 0 && (
          <div className={classes.history}>
            <span className='semibold-16'>Historial de abonos</span>
            {(invoice.payments || []).map((payment, idx) => (
              <div key={idx} className={classes.pay}>
                <FieldBold
                  title={`Fecha de pago: ${moment(payment.date).format('DD/MM/YYYY')}`}
                  value={utils.moneyFormat(payment.payedValue)}
                />
                <Button onClick={() => showDetailPay(payment)} custom='quaternary'>
                  Ver detalles
                </Button>
              </div>
            ))}
          </div>
        )} */}
      </div>
      <NoticeCard
        classNameText={classes.content}
        type='info'
        editHandler={() => { }}
        text='Si tu cliente pagó por otro medio, puedes marcar la cuenta de cobro como pagada y se moverá a pagos recibidos'
        textButton=''
      />
    </div>
  );
};

export default DetailInvoiceCharge;
